import React from "react";
import InvestmentCards from "./InvestmentCards.js";
import CalendlyButton from './components/CalendlyButton';

const Module5 = () => {
  return (
    <div className="py-5 bg-white">
      <div className="">
        <div className="">
          <h3
            className="text-center fw-bold special-font"
            style={{ letterSpacing: "8px", color: "", lineHeight: "22.0px" }}
          >
            PERFIS DE <p> </p>INVESTIMENTOS
          </h3>
        </div>
        <div className="container col-12 col-sm-9">
          <p
            className="text-center mt-5"
            style={{ fontSize: "18px", color: "#111", letterSpacing: "1.8px" }}
          >
            Nosso modelo de investimentos tem estratégias de investimentos para
            todos os perfis, investidores e objetivos.
          </p>
          {/* <p
            className="text-center mt-4"
            style={{ fontSize: "18px", lineHeight: "2.0rem" }}
          >
            Abaixo você pode conhecer cada uma delas e decidir qual é seu
            perfil, caso não saiba seu perfil de investimentos não tem problema,
            trabalharemos em conjunto para definir o melhor tipo de investimento
            antes de avançarmos.
          </p> */}
        </div>
      </div>
      {/* <div className="container-fluid bg-black mt-5" style={{
          height: "50px",
          display: "flex",          // Ativa o Flexbox
          justifyContent: "center", // Centraliza horizontalmente
          alignItems: "center",     // Centraliza verticalmente
        }}>
          <div className="text-white" >
                  ESTRATÉGIAS DE INVESTIMENTOS
           
          </div>
      </div> */}

      <div className="text-black">
        <InvestmentCards />
      </div>

      <div
        className="container col-12 col-md-9 mt-5 text-center"
        style={{
          backgroundColor: "#111111",
          borderRadius: "12px",
          padding: "30px 20px",
          boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.4)",
        }}
      >
        <p
          className="text-center special-font text-white"
          style={{
            fontSize: "clamp(16px, 4.5vw, 20px)",
            letterSpacing: "1.5px",
            lineHeight: "34px", // um pouco mais para respiro
            padding: "0 20px", // padding lateral para não grudar nos cantos
            marginBottom: "30px",
          }}
        >
          Além dessas opções,{" "}
          <span className="fw-bold" style={{ color: "#ECA600" }}>
            estudamos o perfil de cada investidor
          </span>{" "}
          para propor soluções personalizadas — inclusive com estratégias que
          envolvem{" "}
          <span className="fw-bold" style={{ color: "#ECA600" }}>
            a criação de empresas e modelos híbridos de negócio
          </span>
          , com foco em maior rentabilidade e ajuste ao momento de vida de
          cada investidor.
        </p>

        {/* <div className="d-flex justify-content-center align-items-center">
          <button
            className="btn border-0 mb-3 mt-2 px-5 py-3 fw-bold"
            style={{
              backgroundColor: "#ECA600",
              letterSpacing: "1.8px",
              borderRadius: "50px",
              fontSize: "1rem",
              color: "black",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#f0b000";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#ECA600";
              e.target.style.color = "black";
            }}
          >
            DESCUBRA O MELHOR PERFIL PARA VOCÊ
          </button>
        </div> */}
        <div className="">
        
        <CalendlyButton label="AGENDE UMA REUNIÃO E DESCUBRA O SEU PERFIL" />
      </div>
        
      </div>
    </div>
  );
};

export default Module5;
